import { Store } from 'libx'
import { observable, computed, action } from 'mobx'

export default class CouponsScreenStore extends Store {
  @observable couponCode = ''
  @observable fetching = false
  @observable processing = false
  @observable errorMessage = null

  @computed get coupons () {
    return this.rootStore.couponStore.coupons.filter(x => x.redeemed === false)
  }

  @action toggleFetching (fetching) {
    this.fetching = fetching
  }

  @action setCouponCode (code) {
    this.couponCode = code
  }

  @action toggleProcessing (processing) {
    this.processing = processing
  }

  @action setError (message) {
    this.errorMessage = message
  }

  async activate () {
    this.toggleFetching(true)
    try {
      await this.rootStore.couponStore.getCoupons()
    } finally {
      this.toggleFetching(false)
    }
  }

  async applyCoupon () {
    if (!this.couponCode) {
      return
    }
    this.toggleProcessing(true)
    this.setError(null)
    try {
      const result = await this.rootStore.couponStore.addCoupon(this.couponCode)
      if (!result.success) {
        this.setError(result.message)
      }
    } finally {
      this.toggleProcessing(false)
    }
  }
}



// WEBPACK FOOTER //
// ./src/client/store/ui/CouponsScreenStore.js